const t = (s) => x.test(s), x = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/, e = /^((([+]\d{1,3})\s*((1|7)[02369]))|(0(1|7)[02369]))\s*(([-]|())\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*|([0-9]\s*([-]|()))\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*)$/, n = /^07\d{8}$/, o = (s) => e.test(s), a = /^\d{8}[-\s]\d{4}$/, i = /^\d{8}\d{4}$/, r = /^\d{8}$/;
export {
  x as emailRegex,
  t as isEmail,
  o as isPhoneNumber,
  e as phoneRegex,
  n as swedishMobilePhoneNumberRegexWithoutCountryCode,
  a as swedishSnn12NumbersWithDash,
  i as swedishSnn12NumbersWithoutDash,
  r as trailerRentalBookingNumber
};
